module.exports = __webpack_public_path__ + "img/DOGE.8a98c125.svg";